export const moduleName = 'reportVehicleEmissions'

export const FETCH_REPORT = `${moduleName}/FETCH_REPORT`
export const FETCH_REPORT_FULFILLED = `${moduleName}/FETCH_REPORT_FULFILLED`
export const FETCH_REPORT_ERROR = `${moduleName}/FETCH_REPORT_ERROR`

export const REQUEST_DOWNLOAD = `${moduleName}/REQUEST_DOWNLOAD`
export const REQUEST_DOWNLOAD_FULFILLED = `${moduleName}/REQUEST_DOWNLOAD_FULFILLED`
export const REQUEST_DOWNLOAD_ERROR = `${moduleName}/REQUEST_DOWNLOAD_ERROR`

export const SET_DASHBOARD_FILTER = `${moduleName}_set_dashboard_filter`
